class ColorPicker extends HTMLElement {
  constructor() {
    super()

    this.colorPickerSwatches = this.querySelectorAll('.color-picker__swatch')
    this.colorPickerSummary = this.querySelector('.color-picker__summary')
    this.colorPickerCurrentSwatch = this.querySelector('.color-picker__swatch--current')

    this.init()
  }

  init() {
    // Add event listener for mouseenter on color swatches
    this.colorPickerSwatches.forEach((colorPickerSwatch) => {
      colorPickerSwatch.addEventListener('mouseenter', this.handleColorSwatchMouseenter.bind(this))
    })

    this.addEventListener('mouseleave', this.handleElementMouseleave.bind(this))
    this.colorPickerSummary.addEventListener('mouseenter', this.handleElementMouseleave.bind(this))
  }

  handleElementMouseleave() {
    // Add any current classes while hovering
    if (this.colorPickerCurrentSwatch) {
      this.colorPickerCurrentSwatch.classList.add('color-picker__swatch--current')
    }

    // Update title and color name
    const defaultSummaryLabel = this.colorPickerSummary.dataset?.summaryText
    this.updateColorPickerSummary(defaultSummaryLabel, false, '')
  }

  handleColorSwatchMouseenter(colorPickerSwatch) {
    // Remove any current classes while hovering
    if (this.colorPickerCurrentSwatch) {
      this.colorPickerCurrentSwatch.classList.remove('color-picker__swatch--current')
    }

    // Update title and color name
    const productTitle = colorPickerSwatch.target.dataset?.productTitle
    const productColorName = colorPickerSwatch.target.dataset?.productColorName
    this.updateColorPickerSummary(productTitle, true, productColorName)
  }

  updateColorPickerSummary(updateTitle, addTitleActiveClass = false, updateColor) {
    const colorPickerSummaryTitle = this.colorPickerSummary.querySelector('.color-picker__summary-title')
    const colorPickerSummaryColor = this.colorPickerSummary.querySelector('.color-picker__summary-color')

    colorPickerSummaryTitle.innerHTML = updateTitle
    if (addTitleActiveClass) {
      colorPickerSummaryTitle.classList.add('color-picker__summary-title--active')
    } else {
      colorPickerSummaryTitle.classList.remove('color-picker__summary-title--active')
    }

    if (updateColor != '') {
      colorPickerSummaryColor.innerHTML = updateColor
      colorPickerSummaryColor.classList.remove('visually-hidden')
    } else {
      colorPickerSummaryColor.innerHTML = ''
      colorPickerSummaryColor.classList.add('visually-hidden')
    }
  }
}

if (!customElements.get('color-picker')) {
  customElements.define('color-picker', ColorPicker)
}
